// extracted by mini-css-extract-plugin
module.exports = {"PlaceImagesSquare":"PlaceImagesSquare_PlaceImagesSquare__2wIBp","mobile":"PlaceImagesSquare_mobile__3CTpY"};